import React, { FC } from 'react';
import * as S from './styled';
import { ReactComponent as Close } from './img/close.svg';

export interface Props {
	active: boolean;
	setActive: (value: boolean) => void;
	children: React.ReactNode;
	height?: string;
	maxHeight?: string;
	withCloseIcon?: boolean;
}

export const Popup: FC<Props> = props => {
	const { children, setActive, withCloseIcon, active } = props;

	return (
		<S.Container {...props} onClick={() => setActive?.(false)}>
			<S.ContentContainer>
				{withCloseIcon && (
					<S.CloseIcon active={active} onClick={() => setActive?.(false)}>
						<S.CloseImage>
							<Close />
						</S.CloseImage>
					</S.CloseIcon>
				)}
				<S.Content {...props} onClick={e => e.stopPropagation()}>
					{children}
				</S.Content>
			</S.ContentContainer>
		</S.Container>
	);
};
